import ADB from "../../../../libs/MediaSDK";
import { akamai } from "../../../globals";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";
const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
const { PLAY_STATE_CHANGE, SEEKED, SEEKING, DESTROY } = akamai.amp.Events;

class PlayState {
  constructor(amp, tracker, stateObjects) {
    this.amp = amp;
    this.tracker = tracker;
    this.stateObjects = stateObjects;
    this.subscriptions = [];
    //debug.log("[MediaAnalyticsTracking][Mute][constructor]:", this);
  }

  destroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
  end() {
    this.destroy();
  }
  start() {
    this.destroy();
    const { amp } = this;

    const playstate$ = amp.AmpEventsSources[PLAY_STATE_CHANGE].subscribe((data) => {
      this.onPlayStateChange(data);
    });
    const seeking$ = amp.AmpEventsSources[SEEKING].subscribe((data) => {
        this.onSeeking(data);
      });

    const seeked$ = amp.AmpEventsSources[SEEKED].subscribe((data) => {
        this.onSeeked(data);
    });

    const destroy$ = amp.AmpEventsSources[DESTROY].subscribe((data) => {
      this.destroy();
    });
    this.subscriptions = [destroy$, playstate$, seeking$, seeked$];

    if(amp.seeking === true) {
        this.onSeeking();
    }
    if(amp.playState === akamai.amp.PlayState.PLAYING) {
        this.onPlay();
    }
  }

  onPlayStateChange() {
    const { amp } = this;
    switch (amp.playState) {
      case akamai.amp.PlayState.PLAYING:
        this.onPlay();
        break;
      case akamai.amp.PlayState.PAUSED:
        this.onPause();
        break;
    }
  }
  onPause() {
    debug.log("[MediaAnalyticsTracking][PlayState][onPause] tracker.trackPause()");
    this.tracker.trackPause();
  }
  onPlay() {
    const { tracker} = this;
    debug.log("[MediaAnalyticsTracking][PlayState][onPlay] tracker.trackPlay()");
    tracker.trackPlay();
  }

  onSeeked(data) {
    let { tracker } = this;
    const stateName = ADB_MEDIA_EVENTS.SeekComplete;
    debug.log(
        "[MediaAnalyticsTracking][PlayState][onSeeked] tracker.trackEvent \n\tstateName:",
        stateName
      );
    tracker.trackEvent(stateName);
  }
  onSeeking(data) {
    let { amp, tracker } = this;
    if (
      amp.playState != akamai.amp.PlayState.READY
    ) {
      const stateName = ADB_MEDIA_EVENTS.SeekStart;
      debug.log(
          "[MediaAnalyticsTracking][PlayState][onSeeking] tracker.trackEvent \n\tstateName:",
          stateName
        );
      tracker.trackEvent(stateName);
    }
    this.seeking = true;
  }
}

export default PlayState;
